var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-progress-circular',{staticClass:"text-center mx-auto",attrs:{"color":"light-blue-darken-2","id":"loading-circular","indeterminate":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }